import React from 'react';
import { withRouter } from 'react-router-dom';
import { AppInsights } from 'applicationinsights-js';

// Setup ApplicationInsights 
const useApplicationInsights = process.env.REACT_APP_ApplicationInsightsKey !== undefined;
if (useApplicationInsights) {
    AppInsights.downloadAndSetup({ instrumentationKey: process.env.REACT_APP_ApplicationInsightsKey});
}

// handles route changes
class ApplicationInsights extends React.Component {
    constructor(props) {
        super(props);

        this.props.history.listen((location, action) => {
            if (useApplicationInsights)
                AppInsights.trackPageView(location.pathname);
        });
    }

    render() {
        return null;
    }
}

export default withRouter(ApplicationInsights);

// handles tab clicks
export const pageView = (pathname) => {
    if (useApplicationInsights)
        AppInsights.trackPageView(pathname);
}